<template>
    <div class="welcome-wrap">
        <!-- Welcom Start -->
        <div class="welcome-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <div class="welcome-inner text-center">
                            <img src="@/assets/img/vertical-logo.svg" alt="">
                            <p>Your Generative AI Training Platform</p>
                            <router-link to="/login" class="primary-btn">Get started <img src="@/assets/img/arrow-right.svg" alt=""></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Welcome End -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'First'
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/views/First.vue